import { createContext, useState } from 'react'

export const FloatingMenuContext = createContext<{cardStates: any; selectedValue: any; 
  onClick: (key: number, val: string) => void;
  onChangeSelected: (value: number) => void
  }>({
    selectedValue: {},
    onClick: (key: number, val: string) => {},
    onChangeSelected: (value: number) => {},
    cardStates: {}
})

export const FloatingProvider = ({ children }) => {

  const [cardStates, setCardStates] = useState<any>({
    3: 'day',
    4: 'day',
    7: 'month',
    8: 'day',
    9: 'day',
  })

  const [selectedValue, setSelectedValue] = useState<number |null>(null)

  const onClick = (key, val) => {
    // console.log('clickeando...')
    // setValue(val)
    // console.log("Val...", val)
    setCardStates(prevState => ({
      ...prevState,
      [key]: val
    }))
    // setSelectedValue(val)
  }

  const onChangeSelected = (value) => {
    setSelectedValue(value)
  }

  return (
    <FloatingMenuContext.Provider value={{ cardStates, selectedValue, onClick, onChangeSelected }}>
        {children}
    </FloatingMenuContext.Provider>
  )
}
